export default __webpack_public_path__ + "static/media/counter-offer-one.16219a1c.png";